import { render, staticRenderFns } from "./dataProcess.vue?vue&type=template&id=3cf87004&scoped=true&"
import script from "./dataProcess.vue?vue&type=script&lang=js&"
export * from "./dataProcess.vue?vue&type=script&lang=js&"
import style0 from "./dataProcess.vue?vue&type=style&index=0&id=3cf87004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf87004",
  null
  
)

export default component.exports